import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const ChevronRightIcon = ({ size, color, title, decorative, ...restItems }: IconProps) => (
	<IconBase viewBox="0 0 24 24" size={size} color={color} title={title} decorative={decorative} {...restItems}>
		<path
			d="M16.5312 11.4688C16.8125 11.7812 16.8125 12.25 16.5312 12.5312L10.5312 18.5312C10.2188 18.8438 9.75 18.8438 9.46875 18.5312C9.15625 18.25 9.15625 17.7812 9.46875 17.5L14.9375 12.0312L9.46875 6.53125C9.15625 6.25 9.15625 5.78125 9.46875 5.5C9.75 5.1875 10.2188 5.1875 10.5 5.5L16.5312 11.4688Z"
			fill="#31302F"
		/>
	</IconBase>
);
